import React from 'react'
import { useTrans } from '@next-nx/hooks'
import { WImage } from '@next-nx/shared-ui/atoms'
import styles from './OffertaCardSearch.module.sass'
import Link from 'next/link'


interface Props {
  titolo?: string
  url?: string
  image?: string
  className?: string
  onClick?: (event: React.MouseEvent<HTMLAnchorElement>) => void
}

const OffertaCardSearch = (props: Props) => {

  const { 
    titolo = '',
    url = '',
    image = '',
    className = '',
    onClick = () => {}
  } = props

  const t = useTrans()

  const imageBox = <WImage 
    src={image || ""}
    alt={titolo}
    title={titolo}
    maxWidth={160}
    maxHeight={110}
    layout="fill"
    objectFit="contain"
    objectPosition="50% 50%"
  />

  return titolo ? (
    <div className={`${styles.root} ${className}`}>
      {url ? (
        <Link 
          href={url}
        >
          <a className={`${styles.imageBox}`} onClick={onClick}>
            {imageBox}
          </a>
        </Link>
      ) : (
        <div className={`${styles.imageBox}`} role={undefined}>
          {imageBox}
        </div>
      )}
      <div className={styles.content}>
          {url ? (
            <Link
              href={url}
            >
              <a className={styles.title} onClick={onClick}>{titolo}</a>
            </Link>
          ) : (
            <p className={styles.title} role={undefined} tabIndex={undefined}>{titolo}</p>
          )}
      </div>
    </div>
  ) : <></>
}

export default OffertaCardSearch
